export const CountDownTime = 30;
export const CountDownTimeJP = 300;
export const ResendCooldownTimeJP = 30;
